import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const copiarApartamentoService = async (aptoId: number) => {
  const token = validateToken();

  if (!token) {
    throw new Error("Token invalido");
  }

  const url = `${Globais.DOMINIOBACK}/apto/${aptoId}/copiar`;

  try {
    const response = await axios.post(url, undefined, {
      headers: {
        Authorization: token.AuthStr,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error: any) {
    if (error.response?.data) {
      throw error.response.data;
    }

    throw new Error("Erro ao copiar o apartamento");
  }
};
